export default __webpack_public_path__ + "static/latitude-infinity-with-canstar-6d3d023665330e839d23812f47362737.png";